






















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class SideBarBlock extends Vue {
  @Prop({ type: String, default: '' }) label!: string;
  @Prop({ type: String, default: '' }) icon!: string;
  @Prop({ type: Boolean, default: false }) isSpecial!: boolean; // Nouvelle prop
}
